import React, { useId, useMemo } from "react";
import roundTo from "../../../utils/roundTo";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "react-tooltip";

export default function AllocationTracker({
  allocations,
  total,
  showTotal,
  showAllocation,
  allocationAsPercent,
  allocationTrailing,
  units,
  overflowWarning,
}) {
  const id = useId();

  const display = useMemo(() => {
    let filled = 0;

    const entries = allocations.map(({ value, color }) => {
      filled += value;
      return { width: `${100 * (value ?? 0) / total}%`, color };
    });

    return {
      filled,
      entries,
    };
  }, [allocations, total]);

  return (
    <div className="flex gap-1 items-center">
      {(showAllocation && !allocationTrailing) && <span>
        {allocationAsPercent ?
          `${Math.round(100 * display.filled / total)}%` :
          <>{roundTo(display.filled, 2)}{(!showTotal && units) && <>&nbsp;{units}</>}</>
        }
      </span>}
      <div className="w-full flex rounded-full h-4 bg-stone-300 relative overflow-clip">
        {display.entries?.map(({ width, color }, i) => {
          const a = allocations[i];
          return (
            <div
              key={`crop_allo_${id}_${i}`}
              className="h-full hover:brightness-110"
              data-tooltip-id={`allocation-tracker-tooltip-${id}`}
              data-tooltip-content={`${a.name} - ${a.value} ${units}`}
              style={{ width, backgroundColor: color }}
            />
          );
        })}

        {display.filled > total && <FontAwesomeIcon
          icon="triangle-exclamation"
          className="text-orange-400 absolute right-1.5"
          title={overflowWarning}
        />}
      </div>
      {(showAllocation && allocationTrailing) && <span>
        {allocationAsPercent ?
          `${Math.round(100 * display.filled / total)}%` :
          <>{roundTo(display.filled, 2)}{(!showTotal && units) && <>&nbsp;{units}</>}</>
        }
        {showTotal && <>&#x202f;/</>}
      </span>}
      {showTotal && <span>
        {total}{units && <>&nbsp;{units}</>}
      </span>}
      <Tooltip id={`allocation-tracker-tooltip-${id}`} place="bottom" />
    </div>
  );
}
